// Shared inventory. Each app serves these versioned files from its own host.
export const BOTTLE_FILES = Object.freeze({
  '7caf3860-23d4-4796-a9a6-b1b2e2354fd6': 'ayama-56a60d27.glb',
  '78e138ef-266c-4217-817d-84fd72000f87': 'journeys-end-c465a987.glb',
  '0fcf421f-0138-4dc7-b3b8-ffc8720a6a4c': 'chamonix-1ff238fb.glb',
  '1a3527b6-717d-461a-aed2-796dec1ad953': 'blue-canary-59a56b35.glb',
  'ac045e4f-f869-44af-b726-7b11b3fb298b': 'leeuwenkuil-b8ad02f1.glb',
  '95ba9e7b-86a5-486e-ab7c-cc3d6644bb0a': 'viento-48e61cc8.glb',
  'afa71932-72cf-4bf4-aa4c-8553a0562fcc': 'yellowwood-aspoestertjie-2024-07f9e7e9.glb',
  '16229150-124a-40c7-837a-0fe71de50432': 'viento-cinsault-2025-08e8c475.glb',
});

export function bottleAssetFor(wineId) {
  return typeof wineId === 'string' && Object.hasOwn(BOTTLE_FILES, wineId)
    ? `/models/${BOTTLE_FILES[wineId]}`
    : null;
}
